import { types } from 'mobx-state-tree'

const CategoriesForSelect = types.model('CategoriesForSelect', {
  id: types.optional(types.number, 0),
  title: types.maybeNull(types.string),
})

export default CategoriesForSelect
